import { render, staticRenderFns } from "./KeyOverlay.vue?vue&type=template&id=4dd828b2&"
import script from "./KeyOverlay.vue?vue&type=script&lang=js&"
export * from "./KeyOverlay.vue?vue&type=script&lang=js&"
import style0 from "./KeyOverlay.vue?vue&type=style&index=0&id=4dd828b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports